import Vue from 'vue';

export default {
  state: {
    newsCount: 0,
    newsList: [],
    currentNews: {
      preview: {},
      content: '',
    },
  },
  mutations: {
    setNewsCount(state, data) {
      state.newsCount = data;
    },
    setNewsList(state, data) {
      state.newsList = data;
    },
    setCurrentNews(state, data) {
      state.currentNews = data;
    },
  },
  actions: {
    getNewsCount(store) {
      const path = 'newslists/count';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setNewsCount', resp.data);
        return resp.data;
      });
    },
    getNewsList(store, { limit, page = 1 }) {
      let path = 'newslists?_sort=date:desc';

      if (limit) {
        const start = (page - 1) * limit;
        path += `&_limit=${limit}&_start=${start}`;
      }

      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setNewsList', resp.data);
        return resp.data;
      });
    },
    getNewsById(store, id) {
      const path = `newslists/${id}`;
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setCurrentNews', resp.data);
        return resp.data;
      });
    },
  },
};
